export default __webpack_public_path__ + "6f481344106f9b43c6abdfdab5c12634.png";